import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=8b1b3d04"
import script from "./BillingPage.vue?vue&type=script&lang=js"
export * from "./BillingPage.vue?vue&type=script&lang=js"
import style0 from "./BillingPage.vue?vue&type=style&index=0&id=8b1b3d04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports